import { render } from "./SecondTab.vue?vue&type=template&id=efd2c0d6&scoped=true"
import script from "./SecondTab.vue?vue&type=script&lang=js"
export * from "./SecondTab.vue?vue&type=script&lang=js"

import "./SecondTab.vue?vue&type=style&index=0&id=efd2c0d6&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-efd2c0d6"]])

export default __exports__